export const STATUS_VERIFIED = 'verified';
export const STATUS_UNVERIFIED = 'unverified';
